import _ from 'lodash';

import { FIREBASE_CONFIG } from '../config';

function isUserLoggedIn() {
  const key = Object.keys(localStorage).find((e) => e.match(/firebase:authUser/));
  const data = JSON.parse(localStorage.getItem(key));
  console.log('data', data);
  let result = false;
  if (data == null) {
    result = false;
  } else if (!data.emailVerified) {
    result = 'UnVerified';
  } else if (!localStorage.getItem('tenant')) {
    result = 'SelectTenant';
  } else {
    result = 'Verified';
  }

  console.log('isUserLoggedIn', result);
  return result;
}

const getFirebaseUser = () => {
  const key = Object.keys(localStorage).find((e) => e.match(/firebase:authUser/));
  const data = JSON.parse(localStorage.getItem(key));

  return data; //_.assign(data, { tenants, currentTenant });
};

const getProfile = () => {
  return JSON.parse(localStorage.getItem('profile'));
}

const getTenant = () => {
  return JSON.parse(localStorage.getItem('tenant'));
}

const setTenant = (tenant) => {
  return localStorage.setItem('tenant', JSON.stringify(tenant));
}

// const getProfile = () => {
//   const tenants = JSON.parse(localStorage.getItem('tenants'));
//   const currentTenant = JSON.parse(localStorage.getItem('tenant'));
//
//   console.log('emp', tenants[currentTenant.id].employee);
//   return tenants[currentTenant.id].employee;
// };

const hasPermission = (requestedPermissions) => {
  const currentTenant = JSON.parse(localStorage.getItem('tenant'));
  if (!currentTenant || !currentTenant.permissions) {
    return false;
  }

  if (!_.isArray(requestedPermissions)) {
    requestedPermissions = [requestedPermissions];
  }

  const allowed = (currentTenant.permissions || []).find((permission) => requestedPermissions.includes(permission));

  return allowed;
};

const resendEmailVerification = (userId) => {
  console.log('resendEmailVerification', userId);
  return fetch(`${FIREBASE_CONFIG.apiUrl}/v1/auth/verifyemail`, {
    method: 'POST',
    headers: {
      Accept: 'application/json',
    },
    body: userId,
  }).then((res) => {
    console.log('resendEmailVerification', res);
    return res;
  }).catch((err) => {
    console.error(err);
  });
};

const logout = () => {
  localStorage.removeItem('profile');
  localStorage.removeItem('tenant');
  localStorage.removeItem('id_token');
}

export {
  isUserLoggedIn,
  getFirebaseUser,
  hasPermission,
  getProfile,
  getTenant,
  setTenant,
  resendEmailVerification,
  logout,
};



// WEBPACK FOOTER //
// ./src/utils/authenticated.js